import { BackendModule } from "@topyourthree/datastore/core";
import { StoreModule } from "@ngrx/store";
import { SeoNavbarBackend } from "./seo-navbar.backend";
import { SeoNavbarReducer } from "./seo-navbar.reducer";
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "../../core/backend";
export class DatastoreSeoNavbarModule {
}
DatastoreSeoNavbarModule.ɵfac = function DatastoreSeoNavbarModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DatastoreSeoNavbarModule)(); };
DatastoreSeoNavbarModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DatastoreSeoNavbarModule });
DatastoreSeoNavbarModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [StoreModule.forFeature("seoNavbar", SeoNavbarReducer),
        BackendModule.forFeature("seoNavbar", SeoNavbarBackend)] });
